export enum PushTargetType {
    ALL = 'ALL',
    SUBSCRIBER = 'SUBSCRIBER',
    FREE = 'FREE',
    ACTIVE_7D = 'ACTIVE_7D',
    INACTIVE_7D = 'INACTIVE_7D',
    INDIVIDUAL = 'INDIVIDUAL',
}

export interface PushHistoryItem {
    id: number;
    targetType: PushTargetType;
    targetUserId: number | null;
    targetUserEmail: string | null;
    title: string;
    body: string;
    imageUrl: string | null;
    totalTargetCount: number;
    successCount: number;
    failureCount: number;
    sentByEmail: string;
    sentAt: string;
}

export interface PushSendResult {
    historyId: number;
    totalTargetCount: number;
    successCount: number;
    failureCount: number;
}

export interface PushTargetPreview {
    targetType: PushTargetType;
    count: number;
}

export const PushTargetTypeLabels: Record<PushTargetType, string> = {
    [PushTargetType.ALL]: '전체 사용자',
    [PushTargetType.SUBSCRIBER]: '구독자',
    [PushTargetType.FREE]: '무료 사용자',
    [PushTargetType.ACTIVE_7D]: '최근 7일 활성',
    [PushTargetType.INACTIVE_7D]: '7일 이상 미접속',
    [PushTargetType.INDIVIDUAL]: '개별 발송',
};
